<script>
    import {APP_PATH, USER_ROLE} from "../lib/constants";
    import {clickOutside} from "../lib/clickOutside";
    import app from "../stores/app";
    import user from "../stores/user";
    import {router} from '../lib/Router/Router.svelte';
    import Alert from "../stores/alerts";


    let path = "";
    let activePath = '';
    let userId = null;

    let menu = [
        {
            id: 'members',
            name: 'MEMBERS',
            link: `/app/members`,
            icon: 'members',
            visible: true,
            user: [USER_ROLE.ADMIN],
        },
        {
            id: 'hotels',
            name: 'HOTELS',
            link: `/app/hotels`,
            icon: 'hotels',
            visible: true,
            user: [USER_ROLE.ADMIN],
        },
        {
            id: 'checkins',
            name: 'CHECK INS',
            link: `/app/checkins`,
            icon: 'checkins',
            visible: true,
            user: [USER_ROLE.ADMIN, USER_ROLE.RECEPTIONIST],
        },
        {
            id: 'teatro-passes',
            name: 'TEATRO PASSES',
            link: `/app/teatro-passes`,
            icon: 'teatro-passes',
            visible: true,
            user: [USER_ROLE.ADMIN],
        },
        {
            id: 'settings',
            name: 'SETTINGS',
            icon: 'settings',
            visible: false,
            user: [USER_ROLE.ADMIN],
            menu: [
                {
                    id: 'general',
                    name: 'GENERAL',
                    link: `/app/settings`,
                    visible: false,
                    user: null
                },
                {
                    id: 'users',
                    name: 'USERS',
                    link: `/app/users`,
                    visible: false,
                    user: null
                },
                // {
                //     id: 'shipping',
                //     name: 'ΜΕΤΑΦΟΡΙΚΑ',
                //     link: `/app/shipping`,
                //     visible: false,
                //     user: null
                // },
            ],
            menu_expanded: false,
        }
    ];

    const pathFromLink = (link) => {
        return link.replace(window.location.origin, "");
    }

    const toggleMenu = (menu_id) => {
        menu.map(item => {
            if (item.menu) {
                if (item.id === menu_id) {
                    item.menu_expanded = !item.menu_expanded;
                } else {
                    item.menu_expanded = false;
                }
            }
        });
        menu = menu;
    }

    const onMenuItemClick = (event) => {
        event.preventDefault();

        // if ($members.memberIsDirty) {
        //     Alert.confirmExit("Στοιχεία Μέλους", "Έχετε κάνει αλλαγές στα στοιχεία του μέλους.\nΘέλετε να αποχωρήσετε;", () => {
        //         $members.memberIsDirty = false;
        //         onMenuItemClick(event);
        //     });
        //     return;
        // }

        let a = null;
        if (event.target.href) {
            a = event.target;
        } else {
            a = event.target.closest('a');
        }
        let link = pathFromLink(a.href);
        $app.menuExpanded = 0;
        activePath = link;
        router.go(link)();
    }

    const collapseMenu = () => {
        if ($app.menuExpanded > 0) {
            $app.menuExpanded--;
        }
    }

    const initializeMenu = () => {
        console.log("initializeMenu");
        menu.map(item => {
            item.visible = item.user == null || item.user.indexOf($user.role_id) > -1;
            if (item.menu) {
                item.menu.map(subItem => {
                    subItem.visible = subItem.user == null || (subItem.user && subItem.user.indexOf($user.role_id) > -1);
                });
            }
        });
        menu = menu;
    }

    activePath = pathFromLink(window.location.href);

    $: {
        if (userId != $user.id) {
            userId = $user.id;
            initializeMenu();
        }

        if (path !== activePath) {
            // expand current menu
            let arr = activePath.split("/");
            menu.map(item => {
                if (item.menu) {
                    item.menu.map(subItem => {
                        if (arr.indexOf(subItem.id) > -1) {
                            item.menu_expanded = true;
                        }
                    });
                }
            });
            path = activePath;
        }
    }
</script>

<aside class:expanded={ $app.menuExpanded > 0 }>
    <div class="app-header">
        header
    </div>
    <div class="app-menu" use:clickOutside on:click_outside="{ collapseMenu }">
        <div class="app-menu-content">
            {#each menu as item}
                {#if item.visible}
                    {#if item.menu}
                        <div class="app-menu-dropdown">
                            <div class="app-menu-item" on:click="{ () => toggleMenu(item.id) }">
                                <div class="icon">
                                    <img src="/assets/icons/navigation/{ item.icon }.svg">
                                </div>
                                <div class="caption">{ item.name }</div>
                            </div>
                            {#if item.menu_expanded}
                                <div class="app-menu-item-dropdown">
                                    {#each item.menu as subItem}
                                        {#if subItem.visible}
                                            <a href="{ subItem.link }" class="app-menu-item"
                                               class:link-active={ path === subItem.link }
                                               on:click="{ onMenuItemClick }">
                                                <span class="caption">{ subItem.name }</span>
                                            </a>
                                        {/if}
                                    {/each}
                                </div>
                            {/if}
                        </div>
                    {:else}
                        <a href="{ item.link }" class="app-menu-item" class:link-active={ path === item.link }
                           on:click="{ onMenuItemClick }">
                        <span class="icon">
                            <img src="/assets/icons/navigation/{ item.icon }.svg">
                        </span>
                            <span class="caption">{ item.name }</span>
                        </a>
                    {/if}
                {/if}
            {/each}
        </div>
    </div>
</aside>


<style>
    aside {
        position: fixed;
        height: 100vh;
        transition: .3s all ease;
        z-index: 5000;
    }

    .app-header {
        height: var(--header-height);
    }

    .app-menu {
        position: relative;
        width: 100%;
        height: 100%;
        background: #fff;
        border-right: 1px solid #c6d2d9;
        transition: .3s all ease;
        overflow-y: auto;
    }

    .app-menu:before {
        position: absolute;
        content: " ";
        display: block;
        clear: both;
        top: 0;
        bottom: 0;
        left: 0;
        width: 5px;
        background: #03a9f4;
    }

    .app-menu .app-menu-content {
        width: 100%;
    }

    .app-menu-dropdown {
        position: relative;
        /*display: none;*/
    }

    .app-menu-dropdown .app-menu-item-dropdown {

    }

    .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {
        padding-left: 50px;
    }

    @media (max-width: 576px) {
        aside {
            width: 100%;
            left: -100%;
        }

        aside.expanded {
            left: 0;
        }
    }

    @media (min-width: 577px) and (max-width: 999px) {
        aside {
            width: var(--aside-width);
            left: -100%;
        }

        aside.expanded {
            left: 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        aside {
            width: 54px;
        }

        aside:hover, aside.expanded {
            width: var(--aside-width);
        }

        .app-menu {
            width: 100%;
            overflow-x: hidden;
        }

        .app-menu .app-menu-content {
            width: var(--aside-width);
        }

        .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {
            display: none;
        }

        aside:hover .app-menu-dropdown .app-menu-item-dropdown .app-menu-item,
        aside.expanded .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {
            display: block;
        }

        aside .app-menu-item {
            /*padding-right: 0;*/
        }

        aside .app-menu-item .caption {
            /*width: 0;*/
            /*transition: .3s all ease;*/
            /*overflow: hidden;*/
        }

        aside:hover .app-menu-item .caption,
        aside.expanded .app-menu-item .caption {
            /*width: max-content;*/
        }
    }

    @media (min-width: 1025px) {
        aside {
            width: var(--aside-width);
        }
    }

    .app-menu-item {
        position: relative;
        display: flex;
        align-items: center;
        color: #1c1d1d;
        border-left: 5px solid #03a9f4;
        white-space: nowrap;
        padding: 15px;
        cursor: pointer;
        overflow: hidden;
    }

    .app-menu-item .icon {
        display: block;
        width: 18px;
        line-height: 1;
        margin-right: 15px;
    }

    .app-menu-item .icon img {
        width: 100%;
    }

    .app-menu-item .caption {
        display: block;
    }

    .app-menu-item:hover {
        background: #e4eaee;
        border-left-color: #0277bd;
    }

    .app-menu-item.link-active {
        border-left-color: #0277bd;
    }
</style>